import { DropdownOption } from '@ddv/common-components';
import { FormatOperator } from '@ddv/models';

export function showInputRange(selectedOperator: FormatOperator, valueOperators: DropdownOption[]): boolean {
    const operator = valueOperators.find((op) => op.value === selectedOperator);
    return operator ? !!operator.showInputRange : true;
}
